import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks';
import { Button } from '../common';
import './Header.css';

export const Header: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          <span className="logo-icon">🏋️</span>
          <span className="logo-text">ElevatePhysique AI</span>
        </Link>

        <nav className="header-nav">
          {isAuthenticated ? (
            <>
              <Link to="/chat" className="nav-link">
                Chat
              </Link>
              <Link to="/wellness" className="nav-link wellness-link">
                🌿 Wellness
              </Link>
              <Link to="/health-score" className="nav-link health-score-link">
                🏆 Health Score
              </Link>
              <Link to="/profile" className="nav-link">
                Profile
              </Link>
              <div className="nav-user">
                <span className="user-name">{user?.username}</span>
                <Button variant="outline" size="sm" onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            </>
          ) : (
            <>
              <Link to="/login">
                <Button variant="outline" size="sm">
                  Login
                </Button>
              </Link>
              <Link to="/signup">
                <Button variant="primary" size="sm">
                  Sign Up
                </Button>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
